export default __webpack_public_path__ + "static/media/blue_iel.273aec5f.png";